import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { AmplifyHttpClient } from '../auth/http.amplify-httpclient';

@Injectable({
  providedIn: 'root',
})
export class MessengerService {
  constructor(private readonly httpService: AmplifyHttpClient) {}

  public sendMessageApi(request) {
    return this.httpService.post<any>(`api/messenger/save-chat`, request).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  public getMessagesApi(request) {
    return this.httpService.post<any>(`api/messenger/get-messages`, request).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  public sendMessage(request) {}

  public getMessages = () => {
    // return Observable.create((observer) => {
    //   this.socket.on('new-message', (message) => {
    //     observer.next(message);
    //   });
    // });
  };

  public getConversation(request) {
    return this.httpService.post<any>(`api/messenger/get-group-messages`, request).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  public saveOutboxMessage(request) {
    return this.httpService.post<any>(`api/messenger/save-outbox`, request).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  public getOutBoxConversation(request) {
    return this.httpService.post<any>(`api/messenger/get-outbox-messages`, request).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  public deleteOutboxMessage(request) {
    return this.httpService.post<any>(`api/messenger/delete-outbox-message`, request).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }
}
